import { Inline, Stack } from "PFComponents/containers";
import { Tile } from "PFComponents/tile";
import { TooltipIcon } from "PFComponents/tooltip";
import { Typography } from "PFComponents/typography";
import { PropsWithChildren, ReactNode } from "react";

import css from "./skills_tile.module.scss";

type SkillsTileProps = PropsWithChildren<{
  title: string;
  tooltipContent: string | ReactNode;
  customHeaderRightContent?: ReactNode;
}>;

export const SkillsTile = ({
  title,
  tooltipContent,
  customHeaderRightContent,
  children
}: SkillsTileProps) => (
  <Tile paddingVariant="lg" className={css.skillsTile} variant="selected">
    <Stack>
      <Inline alignItems="center">
        <Typography variant="h5">{title}</Typography>
        <TooltipIcon
          content={tooltipContent}
          iconProps={{ size: "sm" }}
          tooltipProps={{
            tooltipContainerProps: { className: css.tooltip }
          }}
        />
        {customHeaderRightContent}
      </Inline>
      <div className={css.content}>{children}</div>
    </Stack>
  </Tile>
);
